import React, { useState, Fragment } from "react";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import NotVerifyIcon from "../../assets/images/NotVerifyIcon.svg";
// import './DeclineModalComponent.css';
import "./NotVerifyModalComponent.css";
import declineShipmentModal from "../../assets/images/declineShipmentModal.png";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import xIcon from "../../assets/images/xmark.svg";
import { useDispatch } from "react-redux";
// import { cancelOrder, deleteOrderById, fetchOrders } from '../../redux/orderSlice';
import {
  fetchAllTrfLabAndTracer,
  notVerifyTrf,
  rejectTrf,
} from "../../redux/trfUserSlice";
import MultiSelect from "../common components/MultiSelect";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    borderRadius: theme.spacing(2), // To adjust the modal borderRadius
  },
}));

const RejectTrfModalComponent = ({
  forModule,
  trfDataById,
  action,
  isOpen,
  onClose,
  updateStateForRejectSuccess,
}) => {
  const [selectedReject, setSelectedReject] = useState([]);
  const option_trf_reject = [
    {
      value: "Incorrect Birla Fibre Type",
      label: "Incorrect Birla Fibre Type",
    },
    { value: "Incorrect Product Type", label: "Incorrect Product Type" },
    { value: "Incorrect Sample image ", label: "Incorrect Sample image " },
    {
      value: "Incorrect Birla Fibre Claimed composition %",
      label: "Incorrect Birla Fibre Claimed composition %",
    },
    {
      value: "Incorrect Fabric Construction Details",
      label: "Incorrect Fabric Construction Details",
    },
    {
      value: "Multiple sample images in SINGLE TRF",
      label: "Multiple sample images in SINGLE TRF",
    },
    { value: "Incorrect Brand name", label: "Incorrect Brand name" },
    { value: "Incorrect Lab address", label: "Incorrect Lab address" },
    { value: "Others", label: "Others" },
  ];

  const [open, setOpen] = React.useState(false);
  const [reasonText, setReasonText] = useState("");
  const dispatch = useDispatch();
  
  const handleTextChange = (e) => {
    setReasonText(e.target.value);
  };

  const handleClose = () => {
    // setOpen(false);
    onClose(false);
  };
  const handleSubmit = () => {
    console.log("Text submitted selectedReject:", selectedReject);
    console.log("JSON STRINGFY", selectedReject.join())
    console.log("Text submitted reasonText:", reasonText);
    console.log("NOT VERIFY MODAL ", trfDataById);
    const trfId = trfDataById.trfId;
    const newReason = selectedReject.join()
    const body = {
      type: "reject",
      rejectReasonText:newReason,
      rejectRemark: reasonText,
      
    };
    console.log("TRF ID ", trfId);
    dispatch(rejectTrf({ trfId, body })).then(() => {
      handleClose()
      updateStateForRejectSuccess(true)
      const queryParams = {
        type: "all-trf",
        searchText: "",
        fromDate: "",
        toDate: "",
        pageSize: 12,
        pageNumber: 1,
        trfStatus: "",
      };
      dispatch(fetchAllTrfLabAndTracer(queryParams));
    });
  };

  //   const handleClickOpen = () => {
  //     setOpen(true);
  //   };
  // console.log('>>> :: DecLine :: <<<', forModule, orderId,action)
  const handleRejectChange = (selectedItems) =>
    setSelectedReject(selectedItems);
  return (
    <div>
      <Fragment>
        {/* <Button variant="outlined" onClick={handleClickOpen}>
          Decline  {forModule}
        </Button> */}
        {/* <button className="icon-clay delete" onClick={handleClickOpen}>
              <span className="inner-clay color-red"> <img src={NotVerifyIcon} alt="Cancel" /></span>
            </button> */}
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={isOpen}
          className="shipmentDeclineModalBody"
        >
          <DialogTitle
            sx={{ m: 0, p: "0px 39px " }}
            id="customized-dialog-title"
          >
            {/* Modal title */}
            <div className="modalImagediv">
              <img
                className="modalImage"
                src={declineShipmentModal}
                alt="modal"
              />
              <h5 className="headingForDeclineShipmentModal">
                {" "}
                Reason for TRF Not Verified{" "}
              </h5>
            </div>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
              backgroundColor: "white",
              height: "7%",
              width: "6%",
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent dividers>
            <Typography gutterBottom>
              <h4 className="titleHeadingForModal">Reason for TRF Rejection</h4>
              <MultiSelect
                //selectionLimit={3}
                // maximumSelectionLength = {3}
                options={option_trf_reject}
                label="Select Reason"
                onChange={handleRejectChange}
                multiple
              />
              <h4 className="titleHeadingForModal">Type Remark</h4>
              <div className="shipmentDeclineModalTextField">
                <TextField
                  label="Enter here"
                  variant="outlined"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "80px",
                    },
                  }}
                  value={reasonText}
                  onChange={handleTextChange}
                  margin="normal"
                />
              </div>
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              onClick={handleSubmit}
              variant="contained"
              color="primary"
              style={{
                width: "400px",
                marginRight: "19%",
                marginLeft: "20%",
                // backgroundColor: "lightgrey",
                // textDecoration: "white",
              }}
              className="btn btn-primary greeen-btn md_btn"
            >
              Reject {forModule}
            </Button>
          
          </DialogActions>
        </BootstrapDialog>
      </Fragment>
    </div>
  );
};
export default RejectTrfModalComponent;
